import type { SVGProps } from 'react';

import { SvgStroke } from '@xemplo/style-constants';
const DawnInvoice = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={props.strokeWidth ?? SvgStroke.Regular}
      d="M9.098 8.097h5.847m-5.847 2.924h4.872m-6.41 7.907c.692-.792 1.746-.729 2.353.135l.852 1.215c.683.963 1.787.963 2.47 0l.852-1.215c.607-.864 1.661-.927 2.352-.135 1.501 1.71 2.724 1.143 2.724-1.25V7.534C19.17 3.91 18.379 3 15.19 3H8.817c-3.187 0-3.98.909-3.98 4.535v10.133c0 2.403 1.231 2.96 2.723 1.26"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
export default DawnInvoice;
